import { createRouter, createWebHashHistory } from 'vue-router';
import store from '../store';
import { ElMessage } from 'element-plus';
export const routes = [{
  path: '/',
  name: '',
  component: () => import('@/views/login/login.vue'),
  redirect: '/login'
}, {
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/login.vue')
}, {
  path: '/staging',
  name: 'Staging',
  component: () => import('@/views/home/index.vue'),
  redirect: '/management',
  children: [{
    path: '/management',
    name: 'Management',
    component: () => import("@/views/management/management.vue"),
    children: [{
      id: '172',
      path: '/supplierCenter/supplierCenter',
      component: () => import('@/views/supplierCenter/SupplierCenter.vue'),
      name: '供应商中心',
      meta: {
        showOperaManual: true,
        keepAlive: true,
        id: '172'
      }
    }, {
      id: '1794',
      name: '明细',
      icon: 'el-icon-document-copy',
      path: '/supplierCenter/supplierDet/:strItems',
      component: () => import("@/views/supplierCenter/supplierDet.vue"),
      meta: {
        keepAlive: true,
        id: '1794'
      }
    }]
  }, {
    path: '/user/info',
    name: 'UserInfo',
    component: () => import("@/views/user/info.vue")
  }]
}];
const router = createRouter({
  history: createWebHashHistory(),
  routes
});
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');

  // 处理URL参数
  const handleUrlParams = to => {
    const params = to.query;
    if (params.code) {
      store.dispatch('setUrlParams', params);
      return true;
    }
    return false;
  };

  // 添加URL参数到目标路由
  const addUrlParamsToRoute = to => {
    const savedParams = store.state.urlParams;
    const routeLocation = {
      name: to.name,
      path: to.path,
      query: {
        ...to.query,
        ...(savedParams || {})
      },
      hash: to.hash,
      params: to.params
    };
    return routeLocation;
  };

  // 验证参数
  if (!handleUrlParams(to)) {
    const savedParams = store.state.urlParams;
    const urlParams = sessionStorage.getItem('urlParams');
    console.log(savedParams, urlParams, '..urlParams');
    if (to.path === '/login' && urlParams == '{}' || !urlParams) {
      console.log(urlParams, '..to');
      store.dispatch('setUrlParams', to.query);
    }
    if (to.path === '/login' && (urlParams == '{}' || urlParams == null)) {
      next();
      ElMessageBox.alert('访问链接缺少必要参数', '温馨提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true
      });
      next(false);
    } else {
      next();
    }
    return;
  }

  // 处理路由跳转
  if (token) {
    if (to.path === '/login' || to.path === '/') {
      next('/staging');
    } else {
      next();
    }
  } else {
    if (to.path === '/login') {
      next();
    } else {
      next(addUrlParamsToRoute({
        path: '/login'
      }));
    }
  }
});
export default router;